import {
  formatErrorWithRequestId,
  getRequestErrorMessage,
  readApiErrorEnvelope,
} from '#/utils/requestError';

/** 成本試算錯誤碼（docs/api/cost-estimate/routes.md）。 */
const COST_ESTIMATE_ERROR_MESSAGES = {
  RESOURCE_VERSION_CONFLICT: '成本試算已被他人修改，請重新載入後再試',
  BOM_VERSION_CONFLICT: 'BOM 已變更，請重新選擇並確認後再匯入',
  COST_ESTIMATE_NAME_REQUIRED: '請輸入試算名稱',
  COST_ESTIMATE_QTY_INVALID: '數量須大於 0、最多 16 位整數與 4 位小數；同物料合併後也不可超過上限',
  COST_ESTIMATE_UNIT_PRICE_INVALID: '單價不可為負且最多四位小數',
  COST_ESTIMATE_LINES_INVALID: '明細內容不正確，請檢查物料、數量與單價',
};

export function isCostEstimateVersionConflict(error) {
  const code = error?.response?.data?.code;
  return code === 'RESOURCE_VERSION_CONFLICT' || code === 'BOM_VERSION_CONFLICT';
}

export function getCostEstimateApiErrorMessage(error, fallback = '操作失敗') {
  const envelope = readApiErrorEnvelope(error);
  const known = envelope?.code ? COST_ESTIMATE_ERROR_MESSAGES[envelope.code] : null;
  if (known && envelope.status < 500) {
    // 數量上限的後端訊息未必提到合併累加，固定用前端說明
    const message = envelope.code === 'COST_ESTIMATE_QTY_INVALID' ? known : (envelope.message || known);
    return formatErrorWithRequestId(message, envelope.requestId);
  }
  const message = getRequestErrorMessage(error, fallback);
  return formatErrorWithRequestId(message, envelope?.status >= 500 ? undefined : envelope?.requestId);
}
